// Categorias fijas de producto. El valor es el que se guarda en products.product_category
// (mismo listado que Product::CATEGORIES en el backend); null = sin clasificar.
export const PRODUCT_CATEGORIES = [
    { value: 'fitoterapeutico', label: 'Fitoterapéutico' },
    { value: 'suplemento dietario', label: 'Suplemento dietario' },
    { value: 'alimento', label: 'Alimento' },
    { value: 'homeopatico', label: 'Homeopático' },
    { value: 'cosmeticos', label: 'Cosméticos' },
];

export const productCategoryLabel = (value) => {
    const category = PRODUCT_CATEGORIES.find((item) => item.value === value);
    return category ? category.label : '';
}

export default {
    PRODUCT_CATEGORIES,
    productCategoryLabel,
}
